import React, { FC } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { NotificationMessage } from './message/NotificationMessage';
import { NotificationWatcher } from './watcher/NotificationWatcher';
import { NotificationWatcherDecision } from './watcher/NotificationWatcherDecision';
import { NotificationFolderWatcher } from './watcher/NotificationFolderWatcher';
import {
  NotificationType,
  NotificationWatcherType,
  NotificationWatcherDecisionType,
  NotificationFolderWatcherType,
  NotificationMessageType,
  NotificationWatcherCommentaryType,
} from '../../notification.types';
import { StateType } from '../../../../state/reducers';
import { NotificationWatcherCommentary } from './watcher/NotificationWatcherCommentary';
import styles from './notification_list.module.scss';

type Props = {
  readNotificationContent: Function;
};

export const NotificationList: FC<Props> = ({ readNotificationContent }) => {
  const { notifList } = useSelector(({ notifications }: StateType) => ({
    notifList: notifications.notifList,
  }));

  const getNotificationRow = (notif: NotificationType) => {
    const watcherNotif = notif as NotificationWatcherType;
    if (watcherNotif.data.watcher) {
      return (
        <NotificationWatcher
          notification={watcherNotif}
          notificationClicked={readNotificationContent}
        />
      );
    }

    const watcherCommentaryNotif = notif as NotificationWatcherCommentaryType;
    if (watcherCommentaryNotif.data.watcherCommentary) {
      return (
        <NotificationWatcherCommentary
          notification={watcherCommentaryNotif}
          notificationClicked={readNotificationContent}
        />
      );
    }

    const watcherDecisionNotif = notif as NotificationWatcherDecisionType;
    if (watcherDecisionNotif.data.watcherDecision) {
      return (
        <NotificationWatcherDecision
          notification={watcherDecisionNotif}
          notificationClicked={readNotificationContent}
        />
      );
    }

    const folderWatcherNotif = notif as NotificationFolderWatcherType;
    if (folderWatcherNotif.data.folderWatcher) {
      return (
        <NotificationFolderWatcher
          notification={folderWatcherNotif}
          notificationClicked={readNotificationContent}
        />
      );
    }

    const messageNotif = notif as NotificationMessageType;
    if (messageNotif.data.message) {
      return (
        <NotificationMessage
          notification={messageNotif}
          notificationClicked={readNotificationContent}
        />
      );
    }
    return <span />;
  };

  return (
    <ul className={styles.container} data-test-id="notification-list">
      {notifList.length > 0 &&
        notifList.map((notif) => (
          <li
            key={notif.id}
            className={styles.item}
            data-test-id="notification-list-item"
          >
            {getNotificationRow(notif)}
          </li>
        ))}
      {notifList.length === 0 && (
        <li className={classNames(styles.item, styles.empty)}>
          Vous n’avez pas encore reçu de notification.
        </li>
      )}
    </ul>
  );
};
